var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-icon"},[_c('el-tooltip',{attrs:{"content":_vm.getTitle(_vm.type),"placement":"top"}},[_c('i',{class:_vm.getClass(_vm.type)})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }